<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">

      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
      >

        <sidebar-item v-for="route in routes"
                      :key="route.path"
                      :item="route"
                      :base-path="route.path"
        />
        
        <god-admin-toggle v-if="isGodAdmin" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import GodAdminToggle from "./GodAdminToggle";

import auth from '@/auth/authService';

export default {
  components: { SidebarItem, Logo, GodAdminToggle },
  computed: {
    ...mapState({
      isCollapse: state => !state.app.sidebar.opened,
    }),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables
    },

    isGodAdmin() {
      return auth.isGodAdmin()
    },

    // isCollapse() {
    //   return true//!this.sidebar.opened
    // }
  }
}
</script>
